export default "__VITE_ASSET__f7f551f0__"